
<template>
    <div id="app">
        <div class="absolute-img">
            <video autoplay loop muted poster="/assets/images/bg.jpg">
                <source src="/assets/treasure_hunter_wo_fire.mp4"  type="video/mp4" />
                <source src="/assets/treasure_hunter_wo_fire.webm" type="video/webm" />
            </video>
        </div>
        <div class="logo">
            <img src="/assets/images/logo.png" />
        </div>
        <router-view/>
    </div>
</template>

<script>

    import config from "./config";

    export default {

        name: 'app-main',

        beforeCreate() {
            this.$http.interceptors.response.use(undefined, err => {
                let res = err.response;
                if (res.status === 401) {
                    window.location.href = config.siteUrl;
                }
            });
        },

        mounted() {

        },

        computed: {

        },
    }
</script>

<style lang="sass">
    @import "assets/css/general"
    @import "assets/css/main"
</style>